/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NewChatBotComponent } from 'src/chatbot/chatbot.component';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { ScrollService } from 'src/chatbot/service/scrollContainer.service';

@Component({
    selector: 'chat-bot-standalone',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        NewChatBotComponent
    ],
    templateUrl: './chat-bot-standalone.component.html',
    styleUrls: ['./chat-bot-standalone.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})

export class ChatBotStandaloneComponent {
    public chatID: InputSignal<string> = input.required<string>();  
    
    private scrollService = inject(ScrollService);
    public dataChatService = inject(DataChatService);
    public isFullScreen = computed(() => this.dataChatService.isFullScreen())
    public isStreaming = computed(() => this.dataChatService.isStreaming())
    public timeout: any;

    constructor() {}

    ngOnInit(){
        this.timeout = setTimeout(() => {
            this.dataChatService.showTooltip.set(true);
        }, 2500);
    }

    toggleChatView(){
        this.hideToolTip();
        this.dataChatService.hideChat.update(prev => !prev);
        if (!this.dataChatService.hideChat()){
            setTimeout(() => {
                this.scrollService.scrollToBottom();
            }, 50);
        }
    }

    hideToolTip(){
        if (this.timeout) 
            clearTimeout(this.timeout)
        
        this.dataChatService.showTooltip.set(false);
    }


}